module.exports = __webpack_public_path__ + "img/symbol_14.c9af9868.png";